var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fill-height":"","fluid":""}},[(!_vm.loading && !_vm.activeMap)?_c('h1',{staticClass:"text-center",attrs:{"id":"no-org"}},[_vm._v("No map found")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }